import { DeleteOutlined, LockOutlined, PlusCircleOutlined, SaveOutlined } from '@ant-design/icons';
import Confirmation from '@app/common/Confirmation';
import { Can } from '@app/modules/Auth';
// import { useStores } from '@app/hooks/stores';
import { Button, Card, Col, Form, Input, Row, Select } from 'antd';
import React, { useMemo } from 'react';

const RoomForm = ({
  listRooms,
  listSubtenants,
  selRoom,
  handleRoomEdit,
  handleRoomChange,
  handleRoomAdd,
  handleRoomNameChange,
  handleRoomSizeChange,
  roomProfChanged,
  handleSubtenantChange,
  handleRoomDelete,
  profileItems
}) => {
  //   const { roomStore } = useStores();
  //   const { listRooms, listSubtenants } = roomStore;

  const roomItems = useMemo(() => {
    return listRooms?.map(room => (
      <Select.Option
        key={room.id}
        value={room.id}
        id={room.id}
        data-device={room.deviceId}
        data-subtenant={room.subtenantId}
        data-profile={room.profileId}
      >
        {room.name}
      </Select.Option>
    ));
  }, [listRooms]);

  const subtenantItems = useMemo(() => {
    return listSubtenants.map(subtenant => (
      <Select.Option key={`${subtenant.id}${subtenant.info}`} value={subtenant.id}>
        {subtenant.info}
      </Select.Option>
    ));
  }, [listSubtenants]);

  return (
    <Col span={12}>
      <Card
        className="card-stats"
        title="Rooms list"
        actions={[
          <Form.Item className="actions">
            <Can
              action="delete:rooms"
              yes={close => (
                <Confirmation
                  onOk={async close => {
                    await handleRoomDelete();
                    close();
                  }}
                  content={`Delete this room ? `}
                  title={`Confirm delete operation`}
                >
                  {open => (
                    <Button
                      type="primary"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={() => open()}
                      disabled={!selRoom.id}
                    >
                      Delete
                    </Button>
                  )}
                </Confirmation>
              )}
              no={() => (
                <Button type="primary" danger disabled icon={<LockOutlined />}>
                  Delete
                </Button>
              )}
            />
            <Can
              action="put:rooms"
              yes={() => (
                <Button type="primary" icon={<SaveOutlined />} onClick={handleRoomEdit} disabled={!selRoom.id}>
                  Save
                </Button>
              )}
              no={() => (
                <Button type="primary" disabled icon={<LockOutlined />}>
                  Save
                </Button>
              )}
            />
            <Can
              action="post:rooms"
              yes={() => (
                <Button icon={<PlusCircleOutlined />} type="primary" onClick={handleRoomAdd}>
                  Add
                </Button>
              )}
              no={() => (
                <Button className="btn btn-success" disabled icon={<LockOutlined />}>
                  Add
                </Button>
              )}
            />
          </Form.Item>
        ]}
      >
        <Row>
          <Col lg={24} md={24}>
            <Form.Item className="vertical-select" rules={[{ required: true }]} label="Select room:">
              <Select value={selRoom?.id} id="roomsList" size="middle" onChange={handleRoomChange}>
                {roomItems}
              </Select>
            </Form.Item>
            <Form.Item className="input-field" rules={[{ required: true }]} label="Room name:">
              <Input type="text" value={selRoom?.name} onChange={handleRoomNameChange} id="roomName" required />
            </Form.Item>
            <Can
              action="patch:rooms"
              yes={() => (
                <>
                  <Form.Item className="input-field" label="Room size:">
                    <Input
                      type="number"
                      min="0"
                      value={selRoom?.size || ''}
                      onChange={handleRoomSizeChange}
                      id="roomSize"
                    />
                  </Form.Item>
                </>
              )}
              no={() => (
                <>
                  <Form.Item className="input-field" label="Room size:">
                    <Input type="number" min="0" value={selRoom?.size} disabled />
                  </Form.Item>
                </>
              )}
            />
            <Form.Item className="select-profile" rules={[{ required: true }]} label="Subtenant:">
              <Select id="v" size="middle" value={selRoom.subtenantId} onChange={handleSubtenantChange}>
                {subtenantItems}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default RoomForm;
